import React, { useState } from "react";
import { Center } from "@/common/css";

import { LightTextWithToolTip } from "@/common/ui/Text";
import { Image } from "@/common/ui/Image";
import { toastErrorMessage, toastSuccessMessage } from "@/utils/helper/myToast";
import Button from "../ui/Button";
import { Check } from "lucide-react";

interface CopyTextProps {
  text: string;
  showIcon?: boolean;
  successMessage?: string;
  errorMessage?: string;
  className?: string;
  textClassName?: string;
}

const CopyText: React.FC<CopyTextProps> = ({
  text,
  showIcon = true,
  successMessage = "Copied to clipboard!",
  errorMessage = "Failed to copy.",
  className = "",
  textClassName = "",
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    if (navigator?.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setIsCopied(true);
          toastSuccessMessage(successMessage);
          setTimeout(() => setIsCopied(false), 2000);
        })
        .catch((err) => {
          toastErrorMessage(errorMessage);
          console.error("Error copying to clipboard: ", err);
        });
    }
  };

  return (
    <Center className={`w-full !justify-start ${className}`}>
      <LightTextWithToolTip text={text} className={textClassName} />
      {showIcon && (
        <Button variant="transparent" className="!p-0 !min-w-12" onClick={handleCopy}>
          {isCopied ? <Check className="text-text-primary" size={15} /> : <Image src="/icons/copy.svg" alt="copy-icon" />}
        </Button>
      )}
    </Center>
  );
};

export default CopyText;
